const LoadingIndicator = ({className}) => (
    <i className={"fa-3x fas fa-circle-notch fa-spin "+ className} />
);
LoadingIndicator.defaultProps = {
    className: '',
};

export default LoadingIndicator;
